/**
 * PageViewTracker.tsx
 * 
 * Component to track page views in Google Analytics using React Router
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../utils/analytics'

const PageViewTracker: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search)
  }, [location])

  return null
}

export default PageViewTracker

